
import RequestCredit from '~/pages/_lang/request-credit.vue'
export default RequestCredit
